// HomeHero.jsx
import { useNavigate} from "react-router-dom";

import "./HomeHero.css";
import safety from "../assets/Home/Safety(homeargus).png"
import traceability from "../assets/Home/Traceability(homeargus).png"
import productivity from "../assets/Home/Productivity(homeargus).png"

import Btn_rect from "./Btn_rect.js";


export default function HomeHero() {
  const navigate = useNavigate();
  return (
    <section className="hero">
      {/* Top Heading */}
      <div className="hero-heading">
        <h1>
          Not Just What We Do,
          <br />
          What You Count On.
        </h1>
      </div>

      {/* Bottom Content */}
      <div className="hero-features">
        <div className="feature">
          <h3>Traceability</h3>
          <p>
            From the first bolt to the final box, we track it all in real time.
            No more guesswork, no blind spots, just complete visibility.
          </p>
          <img className="hero-features-image" src={traceability}></img>
          <div className="btn_wrapper">
              <Btn_rect label="Start Now" onClick={()=>{navigate('/supplychain')}}/>
          </div>
        </div>

        <div className="feature">
          <h3>Productivity</h3>
          <p>
            Automated checks, adaptive safety systems, reduce risk before it
            spirals. Built-in compliance, every step.
          </p>
          <img className="hero-features-image" src={productivity}></img>
         <div className="btn_wrapper">
              <Btn_rect label="Start Now"  onClick={()=>{navigate('/Smart')}} />
          </div>
        </div>

        <div className="feature">
          <h3>Safety</h3>
          <p>
            Every pause comes with a price tag. Stay ahead of stalls and keep
            your floor moving smoothly.
          </p>
          <img className="hero-features-image" src={safety}></img>
          <div className="btn_wrapper">
              <Btn_rect label="Start Now"  onClick={()=>{navigate('/Security')}}/>
          </div>
        </div>
        
      </div>
    </section>
  );
}
